import Button from "@/components/Button";
import CourseInfo from "./CourseInfo";
import useIsOfferOwned from "../hooks/useIsLectureOwned";

function Offerlecture({ lecture, grade, isOwned }) {
    const {
        attributes: { name, brief, courseId },
        id,
    } = lecture;


    return (
        <div className="flex flex-col items-center justify-between w-full gap-10 p-10 rounded-lg lg:flex-row bg-primary-color-mid">
            {/* img */}
            <div className="w-100">
                <img
                    src="/images/courses/courseImage.webp"
                    alt="course icon"
                    className="w-100"
                    loading="lazy"
                    decoding="async"
                />
            </div>
            {/*  */}
            <div className="flex flex-col items-center justify-between w-full gap-3 lg:flex-row">
                {/* name and breif */}
                <CourseInfo
                    name={name}
                    brief={brief}
                    maxName={10}
                    maxBrief={30}
                />
                {
                    isOwned &&
                    <Button
                        name="go to the course lectures page"
                        to={`/${grade}/courses/${courseId}/lectures/${id}`}
                        type="primary"
                    >
                        الدخول للمحاضره
                    </Button>
                }
            </div>
        </div>
    );
}

export default Offerlecture;
